export const wishlistModal = () => {
  const modalInstances = {};
  const breakpoint = Foundation.MediaQuery.current;
  // generate wishlist modals
  $('.wishlist-modal:not(.initialized)').each((i, el) => {
    const $modal = $(el);
    const id = $modal.data('id');
    $modal.addClass('initialized');
    if (!Object.prototype.hasOwnProperty.call(modalInstances, id)) {
      modalInstances[id] = new Foundation.Reveal($modal);
    }

    // const $modalError = $modal.find('.wishlist-modal-error-wrapper');

    let pid;
    $modal.find('.wishlist-list-size li').click((e) => {
      $(e.currentTarget).siblings().removeClass('selected');
      $(e.currentTarget).addClass('selected');
      pid = $(e.currentTarget).data('id');
      $modal.find('.add-to-wishlist-modal').attr('disabled', false);
    });

    $modal.find('.add-to-wishlist-modal').click((e) => {
      const url = $(e.currentTarget).data('url');
      const modalID = $(e.currentTarget).data('id');
      if (!pid) return;

      $.ajax({
        url: url,
        method: 'POST',
        data: {
          pid
        },
        success: (data) => {
          if (breakpoint !== 'large' && breakpoint !== 'xlarge' && breakpoint !== 'xxlarge') {
            if (!$('.add-to-wl-messages').hasClass('show')) {
              var link = $('.add-to-wl-messages').attr('data-href');
              $('.add-to-wl-messages').append(
                `<div class="add-to-wl-alert success text-center" role="alert">
                                        <a href="${link}">
                                            ${data.msg}
                                        </a>
                                    </div>`
              ).addClass('show');

              setTimeout(function () {
                $('.add-to-wl-messages').removeClass('show');
                $('.add-to-wl-alert').remove();
                $('.header-toolbar .wishlist-icon, .mobile-pane-header .wishlist-render').addClass('has-wishlist-list');
                $modal.find('.add-to-wishlist-modal').attr('disabled', true);
                $modal.find('.wishlist-list-size li').removeClass('selected');
                modalInstances[modalID].close();
              }, 1500);
            }
          } else {
            $('.header-toolbar .wishlist-icon, .mobile-pane-header .wishlist-render').addClass('has-wishlist-list');
            $modal.find('.add-to-wishlist-modal').attr('disabled', true);
            $modal.find('.wishlist-list-size li').removeClass('selected');
            modalInstances[modalID].close();
            // $(`#wishlist-modal-${modalID}`).foundation('close');
          }

          $('.wishlist-modal-open[data-id=' + modalID + ']').addClass('is-in-wishlist');

          let event_action = '';
          let action = $('.js-page').data('action');
          if (action === 'Home-Show') {
            event_action = 'homepage';
          } else if (action ===  'Search-Show') {
            event_action = 'category_page';
          } else {
            event_action = (action || action.length >0 ) ? action.split('-')[0].toLowerCase() + '_page' : 'undefined_action';
          }

          // Trigger Goal Event: wishlist_created
          if (data.created) {
            dataLayer.push({
              gaHitType: 'event',
              event: 'goal_event',
              event_category: 'wishlist_created',
              event_action: event_action,
              event_label: pid.replace(/_([^_]*)$/, '|$1', '|$1')
            });
          }
        },
        error: (error) => {
          console.log('error in process request', error);
          // Callout.error(null, error.)
        }
      });
    });
  });

  // open modals
  $('.wishlist-modal-open:not(.initialized)').each((i, el) => {
    const $openWishlistLink = $(el);
    $openWishlistLink.addClass('initialized');

    $openWishlistLink.click((e) => {
      const modalID = $(e.currentTarget).data('id');
      if (modalInstances[modalID] !== 'undefined') {
        modalInstances[modalID].open();
      }
    });
  });
};

class wishlistAdd {
  run() {
    this.addToWishlist();
    $(window).off('wishlist:initialize').on('wishlist:initialize', (e, data) => {
      this.addToWishlist();
      wishlistModal();
    });
  }

  addToWishlist() {
    $(document).on('click', '.add-to-wish-list', (e) => {
      e.preventDefault();

      const self = $(e.currentTarget);
      const url = (!self.hasClass('is-in-wishlist')) ? (self.attr('href') || self.attr('data-action-add')) : self.attr('data-remove-url');
      const headerWishlist = $('.header-toolbar .wishlist-icon');
      const headerWishlistMobile = $('.mobile-pane-header .wishlist-render');
      const breakpoint = Foundation.MediaQuery.current;

      let pid = self.closest('.product-detail').attr('data-pid') || self.attr('data-pid');
      let optionId;
      let optionVal;

      optionId = optionId || null;
      optionVal = optionVal || null;

      const addToWishlistCall = (u, id, optId, optVal) => {
        self.attr('disabled', true);

        $.ajax({
          url: u,
          type: 'post',
          dataType: 'json',
          data: {
            pid: id,
            optionId: optId,
            optionVal: optVal
          },
          success: (data) => {
            self.attr('disabled', false).addClass('is-in-wishlist');

            if (!headerWishlist.hasClass('has-wishlist-list')) {
              headerWishlist.addClass('has-wishlist-list');
            }

            if (!headerWishlistMobile.hasClass('has-wishlist-list')) {
              headerWishlistMobile.addClass('has-wishlist-list');
            }

            if (self.parent('.edit-add-to-wishlist').length) {
              self.closest('.card').find('.add-to-wish-list').each((index, el) => {
                el = $(el);
                const label = el.attr('data-remove-label');
                el.addClass('is-in-wishlist').children('.label').text(label).attr('title', label);
              });
            }

            if (self.parents('#size-modal-wishlist').length) {
              $('#size-modal-wishlist .close-modal').trigger('click');
              $('.product-detail .add-to-wish-list').addClass('is-in-wishlist');
            }
            if (breakpoint !== 'large' && breakpoint !== 'xlarge' && breakpoint !== 'xxlarge') {
              if (!$('.add-to-wl-messages').hasClass('show')) {
                var link = $('.add-to-wl-messages').attr('data-href');
                $('.add-to-wl-messages').append(
                  `<div class="add-to-wl-alert success text-center" role="alert">
                                        <a href="${link}">
                                            ${data.msg}
                                        </a>
                                    </div>`
                ).addClass('show');

                setTimeout(function () {
                  $('.add-to-wl-messages').removeClass('show');
                  $('.add-to-wl-alert').remove();
                }, 3500);
              }
            }

            let event_action = '';
            let action = $('.js-page').data('action');
            if (action === 'Home-Show') {
              event_action = 'homepage';
            } else if (action ===  'Search-Show') {
              event_action = 'category_page';
            } else {
              event_action = (action || action.length >0 ) ? action.split('-')[0].toLowerCase() + '_page' : 'undefined_action';
            }
            // Trigger Goal Event: wishlist_created
            if (data.created) {
              dataLayer.push({
                gaHitType: 'event',
                event: 'goal_event',
                event_category: 'wishlist_created',
                event_action: event_action,
                event_label: pid.replace(/_([^_]*)$/, '|$1', '|$1')
              });
            }
          },
          error: (err) => {
            console.log(err);
          }
        });
      };

      const removeWishlist = (u) => {
        $.ajax({
          url: u,
          type: 'get',
          dataType: 'json',
          data: {},
          success: (data) => {
            self.attr('disabled', false).removeClass('is-in-wishlist');

            if (data.list.length === 1) {
              headerWishlist.removeClass('has-wishlist-list');
              headerWishlistMobile.removeClass('has-wishlist-list');
            }

            if (self.parent('.edit-add-to-wishlist').length) {
              self.closest('.card').find('.add-to-wish-list').each((index, el) => {
                el = $(el);
                const label = el.attr('data-add-label');
                el.removeClass('is-in-wishlist').children('.label').text(label).attr('title', label);
              });
            }
          },
          error: () => {
            document.location.reload();
          }
        });
      };

      if (!url || !pid || self.attr('disabled') || self.hasClass('disabled')) {
        return;
      }

      if ($('.list-size').length) {
        if ($('.list-size > li.selected').length === 0) {
          if ($('.size-modal-wishlist-button').length) {
            $('.size-modal-wishlist-button').trigger('click');
          } else if ($('.list-size').next('.error-msg').length === 0) {
            const div = $('<div class="error-msg"></div>');
            const errorMsg = $('.variation-attr').attr('data-error-msg');
            div.text(errorMsg).insertAfter('.quick-view-details .list-size');
          }
        } else if (!self.hasClass('is-in-wishlist')) {
          addToWishlistCall(url, pid, optionId, optionVal);
        } else {
          removeWishlist(url);
        }
      } else if (!self.hasClass('is-in-wishlist')) {
        addToWishlistCall(url, pid, optionId, optionVal);
      } else {
        removeWishlist(url);
      }
    });
  }
}

const WishlistAdd = new wishlistAdd();
export default WishlistAdd;



// WEBPACK FOOTER //
// ./assets/scripts/components/wishlist.js